import { useSelector } from 'react-redux';
import { selectAppId } from 'store/v1/auth/auth.selectors';
import { myEnterpriseService } from '../../io/EnterpriseService/EnterpriseService.connected';
import { createAppScopeService } from './AppScopeService.impl';

export const myAppScopeService = createAppScopeService({
  enterpriseService: myEnterpriseService,
  useAuthOrganizationId: () => {
    const appId = useSelector(selectAppId);
    return typeof appId === 'string' ? appId : undefined;
  }
});
